import React from 'react'
import NewsDetailsComp from '../Components/newsdetailssection.jsx/NewsDetailsComp'


function NewsDetails() {
  return (
    <>
   <NewsDetailsComp />
    </>
  )
}

export default NewsDetails